import _ from 'lodash';
import React from 'react';
import styles from './multiselect.scss';

import {
  MultiSelect as WixMultiselect,
  MultiSelectTag,
} from '@wix/design-system';

export interface MultiselectOption {
  id: string;
  value: React.ReactNode | string;
  disabled?: boolean;
  overrideStyle?: boolean;
}

interface Props {
  onEnterPressed?: () => void;
  id?: string;
  name?: string;
  error?: boolean;
  errorMessage?: string;
  disabled?: boolean;
  dataHook?: string;
  placeholder?: any;
  tags: MultiSelectTag[];
  options?: MultiselectOption[];
  onChange: any;
  onBlur?: any;
  manualInput?: boolean;
  autoFocus?: boolean;
}

interface State {
  inputValue: string;
  tags: MultiSelectTag[];
}

export class MultiSelect extends React.Component<Props, State> {
  public static defaultProps = {
    manualInput: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
      tags: props.tags || [],
    };
  }

  public UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.shouldResetTags(nextProps)) {
      this.resetTags();
    }
  }

  private shouldResetTags({ options }: Props) {
    return !_.isEqual(options, this.props.options);
  }

  private resetTags() {
    this.setState({ tags: [] });
  }

  private onSelect(tag) {
    const { options } = this.props;

    if (_.isEmpty(options)) {
      return;
    }

    if (_.isArray(tag)) {
      tag = tag[0];
    }

    const suggestedTag: MultiselectOption | undefined =
      _.find<MultiselectOption>(options, { id: tag.id });

    if (!suggestedTag) {
      return;
    }

    tag = {
      id: suggestedTag.id,
      label: suggestedTag.id,
    };

    const tags = [...this.state.tags, tag];

    this.setState({ tags });
    this.props.onChange(tags);
  }

  private onChange(event) {
    const inputValue = event && event.target && event.target.value;
    if (inputValue) {
      const tag = {
        id: inputValue,
        label: inputValue,
      };
      const tags = [...this.state.tags, tag];
      this.props.onChange(tags);
    }
    this.setState({
      inputValue,
    });
  }

  private onManuallyInput(tags: string[]) {
    const labeledTags = _.map(tags, (tag) => ({
      id: tag,
      label: tag,
    }));

    const { manualInput } = this.props;

    if (!manualInput) {
      return;
    }

    const newTags = _.uniqBy<any>(
      [...this.state.tags, ...labeledTags],
      (tag: { id: string; label: string }) => tag.id,
    );

    this.setState({
      tags: newTags,
      inputValue: '',
    });
    this.props.onChange(newTags);
  }

  private onRemoveTag(tag: string) {
    const tags = _.filter(this.state.tags, (tagItem) => tagItem.id !== tag);

    this.setState({
      tags,
    });
    this.props.onChange(tags);
  }

  private predicate({ value }) {
    const inputValue = _.toLower(this.state.inputValue);
    return _.toLower(value).indexOf(inputValue) > -1;
  }

  private handleBlur(event) {
    const tagName = event && event.target && event.target.value;

    const { onBlur } = this.props;

    onBlur();

    if (!tagName) {
      return;
    }

    this.onManuallyInput([tagName]);
    this.setState({
      inputValue: '',
    });
  }

  public render() {
    const { options, errorMessage, error } = this.props;
    const { inputValue, tags } = this.state;
    return (
      <div className={styles.multiselect}>
        <WixMultiselect
          {...this.props}
          tags={tags}
          status={(error && 'error') || undefined}
          statusMessage={errorMessage}
          onSelect={this.onSelect.bind(this)}
          onRemoveTag={this.onRemoveTag.bind(this)}
          onChange={this.onChange.bind(this)}
          onManuallyInput={this.onManuallyInput.bind(this)}
          options={options}
          value={inputValue}
          predicate={this.predicate.bind(this)}
          onBlur={this.handleBlur.bind(this)}
        />
      </div>
    );
  }
}
